import i18n from 'i18next'
import { FormInputConfig, FormInputItem } from '../../../../utils/formUtils/types'

export const inputsConfig = (): FormInputConfig => ({
    mainForm: [
        { label: i18n.t('form.diary.fullName'), name: 'fullName', required: true },
        { label: i18n.t('app.common.property.type'), name: 'propertyType', required: true },
        { label: i18n.t('app.common.spaceArea'), name: 'areaNett', required: true },
        { label: i18n.t('app.common.registry.insert'), name: 'propertyRegistryInsert', required: true },
        { label: i18n.t('app.common.cadastralMunicipality'), name: 'propertyCadastralMunicipality', required: true },
        { label: i18n.t('form.diary.finalPrice'), name: 'finalPrice', required: true },
        { label: i18n.t('app.common.conclusionPlace'), name: 'conclusionPlace', required: true },
        { label: i18n.t('app.common.conclusionDate'), name: 'conclusionDate', required: true },
        { label: i18n.t('form.diary.finalPaymentDate'), name: 'finalPaymentDate', required: true },
        { label: i18n.t('app.common.creationDate'), name: 'intermediaryDiaryDate', required: true },
    ] as FormInputItem[],
})
